<template>
  <div class="slider-item u-white u-overflow-hidden">
    <div class="u-relative">
      <!-- <app-scroll :isHor="true" :isAbolute="false"> -->
        <div class="slider-item__titles u-left u-top u-pad-l-md">
          <div
            v-for="(keypoint, index) in data"
            @click="$emit('selected', index)"
            class="slider-item__titles__title u-flex t-h2 u-marg-r-sm u-cursor-pointer u-pad-b-md u-center"
            :class="{'is-active': selectedIndex === index}"
          >
            {{ keypoint.titre }}
          </div>
        </div>
      <!-- </app-scroll> -->
    </div>
    <div class="slider-item__wrapper u-relative">
      <div
        v-for="(keypoint, index) in data"
        class="slider-item__slide u-wrapper-panel u-pad-md"
        :style="{transform: `translate3d(${(index - selectedIndex) * 100}%, 0, 0)`}"
      >
        <div class="u-full-width u-full-height u-relative u-overflow-hidden">
          <!-- <app-scroll :isActive="index === selectedIndex" :isAbolute="true"> -->
          <div>
            <div class="slider-item__slide__wrapper u-bg-black u-pad-md">
              <div>
                <div class="slider-item__slide__tag t-text--big u-inline-block u-pad-xs">
                  {{ keypoint.category }}
                </div>
              </div>
              <div class="t-h3 u-marg-t-sm">
                {{ keypoint.titre }}
              </div>
              <div class="t-text t-text--small u-marg-t-sm">
                {{ formatDate(keypoint.date) }} - {{ keypoint.duration }} read
              </div>
              <div class="t-text t-text--small u-marg-t-sm">
                {{ keypoint.author }}
              </div>
              <div class="u-net u-w5of8 u-marg-t-sm" />
              <div class="slider-item__slide__image u-marg-t-sm">
                <div v-if="keypoint.sbsVideo.length" >
                  <div class="u-box-16by9">
                    <video-player v-if="keypoint.sbsVideo.length" :src="keypoint.sbsVideo[0].url" :subtitles="keypoint.sbsSubtitles.length ? keypoint.sbsSubtitles[0].url : ''" />
                    <youtube-player v-else :id="keypoint.sbsIdVimeo" />
                  </div>
                </div>
                <app-image v-else-if="keypoint.image.length" :id="keypoint.image[0].id" class="u-full-width" :width="400" />
              </div>
              <div class="t-text u-marg-t-sm u-grey-light">
                {{ keypoint.subtitle }}
              </div>
              <div class="t-text u-marg-t-sm u-white" v-html="keypoint.text" />
            </div>
          </div>
          <!-- </app-scroll> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppScroll from '@/components/common/AppScroll'
import VideoPlayer from '@/components/common/VideoPlayer'
import YoutubePlayer from '@/components/common/YoutubePlayer'

export default {
  components: {
    AppScroll,
    VideoPlayer,
    YoutubePlayer
  },
  props: {
    data: {
      type: Array,
      default: () => {return []}
    },
    selectedIndex: {
      type: Number,
      default: -1
    }
  },
  methods: {
    formatDate (date) {
      date = new Date(date)
      return `${this.formatMonth(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`
    },
    formatMonth (mounth) {
      switch (mounth){
        case 0:
          return 'Jan'
          break
        case 1:
          return 'Fev'
          break
        case 2:
          return 'Mar'
          break
        case 3:
          return 'Apr'
          break
        case 4:
          return 'May'
          break
        case 5:
          return 'Jun'
          break
        case 6:
          return 'Jul'
          break
        case 7:
          return 'Aug'
          break
        case 8:
          return 'Sep'
          break
        case 9:
          return 'Oct'
          break
        case 10:
          return 'Nov'
          break
        case 11:
          return 'Dec'
          break
        default:
          return ''
          break
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/easings'

.slider-item
  &__titles
    flex-wrap nowrap
    display flex

    &__title
      max-width 40%
      position relative
      
      &:before
        border-radius 2px
        position absolute
        bottom 0
        left 0
        width 100%
        content ''
        height 3px
        background url('/images/gradient.jpg')
        background-size 100% 100%
        opacity 0
        transition opacity .5s linear
      
      &.is-active:before
        opacity 1
        transition opacity .5s .5s linear

  &__wrapper
    height calc( 100vh - 270px )

  &__slide
    transition transform 1s ease-in-out-quart
    
    &__image
      overflow hidden
      border-radius 15px

    &__wrapper
      border-radius 20px

    &__tag
      background url('/images/gradient.jpg')
      background-size 100% 100%
      border-radius 4px

</style>